/**
 * MapLibre GL JS shim — bridges `import mapboxgl from 'mapbox-gl'` to `window.maplibregl`.
 *
 * MapLibre GL JS is loaded from CDN as a blocking <script> in index.html <head>,
 * which guarantees `window.maplibregl` is available before any ES module code runs.
 *
 * This shim lets existing code keep `import mapboxgl from 'mapbox-gl'` unchanged.
 * Vite resolves `mapbox-gl` → this file via resolve.alias in vite.config.ts.
 *
 * CSS is also loaded from CDN (no JS import needed).
 */

const maplibregl = (window as any).maplibregl;

if (!maplibregl) {
  console.error(
    '[maplibre-gl-shim] window.maplibregl is not defined. ' +
    'Check that the MapLibre CDN <script> is in index.html <head>.'
  );
}

export default maplibregl;
